import { Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CannotOpenSession, CpxCard, CpxCardRipped, ExpiredCardError, MultipleCpxCards, NoCPXCard, StellairAccessTokenError, StellairHealthcareTokenError, StellairListTerminauxError, TooManyPinCodeError, WirelessConnectError, WrongPinCode } from 'src/app/services/cpx-handle/cpx-handle.error';
import { CpxHandleServiceAbstract, SessionTypeEnum, TypeConnecteurEnum, WirelessModeCardType } from 'src/app/services/cpx-handle/cpx-handle-service-abstract';
import { ModalService } from 'src/app/services/modal/modal.service';
import { CpxCardSignatureResponseInterface, CpxCardSignatureResponsePracticeLocationsInterface } from 'src/app/utils/interfaces/new/cpx-signature-response-interface';
import { CpxSessionInterface, CpxTypeEnum } from 'src/app/utils/interfaces/new/cpx-session.interface';
import { environment } from 'src/environments/environment';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { CpxCardTypeEnum } from 'src/app/utils/interfaces/new/cpx-card-type-enum';
import { RessourceService } from 'src/app/services/ressource/ressource.service';
import { ProfilService } from 'src/app/services/profil/profil.service';
import { SessionService } from 'src/app/services/cpx-handle/connecteur-dinno/models';
import { ChirDentisteSpecialities, MedecinSpecialities, PharmacienSpecialities } from 'src/app/services/cpx-handle/cpx-handle-utils.service';
import { SUBJECT_ROLE_CODES_AUTORIZED } from 'src/app/services/dmp/dmp-service.abstract';
import { StellairService } from 'src/app/services/stellair/stellair.service';
import { WIRELESS_MODE_CPX_CARD_NAME } from 'src/app/services/cpx-handle/cpx-handle.service';

export interface HandleCpxResponse {
  data?: any;
  pinCode?: string;
  error?: {
    message: string;
  };
}

enum HandleCpxModalStateEnum {
  'selectSlot' = 1,
  'pinKeyboard' = 2,
  'confirmationMessage' = 3,
  'noCpxCard' = 4,
  'rippedCard' = 5,
  'selectPracticeLocation' = 6,
  'unableToOpenSession' = 7,
  'expiredCard' = 8,
  'wirelessConnectError' = 9,
  'defaultError' = 10,
}

interface NgSelectValuePracticeLocation {
  id: string;
  libelle: string;
  meta: CpxCardSignatureResponsePracticeLocationsInterface;
  disabled?: boolean;
}

interface NgSelectValue {
  id: string;
  libelle: string;
}

@Component({
  selector: 'app-handle-cpx-modal',
  templateUrl: './handle-cpx-modal.component.html',
  styleUrls: [
    './handle-cpx-modal.component.scss',
    '../modal.fragment.scss'
  ]
})
export class HandleCpxModalComponent implements OnInit, OnDestroy {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public currentState: HandleCpxModalStateEnum;
  public currentStateTpt = HandleCpxModalStateEnum;
  public currentStateMessageTpt: string;
  public isLoading = true;
  public multipleCpxCards: Array<string>;
  public pinCode: string;
  private _cardSlotId: number;
  private _cardSlotName: string;
  public formGroupPinCode: FormGroup;
  public cpfForm: FormGroup;
  public isErrorWrongPin = false;
  public practiceLocations: Array<NgSelectValuePracticeLocation> = [];
  public isUnautorizedPracticeLocation = false;
  public showPracticeLocation = true;
  private _cpxCardType: CpxSessionInterface;
  public moreInfoOnLoginNeed: string | undefined = undefined;
  public cpxType: CpxTypeEnum | undefined = undefined;
  public cpxTypeTpl = CpxTypeEnum;
  public healthcarefacilitytypecodes: Array<NgSelectValue>;
  public practicesettingcodes: Array<NgSelectValue>;
  public specialitiescodes: Array<NgSelectValue>;

  public typeConnecteur: TypeConnecteurEnum = TypeConnecteurEnum.DMPConnect

  @Output() public closeEmitterHandleCpx = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (this.modalBody && !this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _cpxHandleSrv: CpxHandleServiceAbstract,
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _formBuilder: FormBuilder,
    private _refSrv: ReferentielService,
    private _ressourceSrv: RessourceService,
    private _profilSrv: ProfilService,
    private _dinnoSessionSrv: SessionService,
    private _stellairSrv: StellairService,
  ) { }

  ngOnInit(): void {
    this._initData();
  }

  ngOnDestroy(): void {
    this.moreInfoOnLoginNeed = undefined;
  }

  public async selectCpxCard(slotName): Promise<void> {
    this.isLoading = true;

    try {
      await this._findCpxCard(slotName);
    } finally {
      this.isLoading = false;
    }
  }

  public async readCard(pinCode: string): Promise<void> {
    this.isLoading = true;

    try {
      await this._readCard(pinCode);
    } finally {
      this.isLoading = false;
    }
  }

  public selectPracticeSetting(location: string): void {

    console.log('selectPracticeSetting - location : ', location);
    if(!this.typeConnecteur || this.typeConnecteur === TypeConnecteurEnum.DMPConnect) {
      this._cpxHandleSrv.selectPracticeSettingIndice(this.practiceLocations.findIndex(pl => pl.id === location));
      this.closeModal({ data: this._cpxCardType, pinCode: this.pinCode });
    } else {
      this.closeModal({ data: {slotId: this._cardSlotId, situation: Number(location)}, pinCode: this.pinCode,});
    }
  }

  public setPracticeSetting() {
    // TODO !!
    const nomStructure = this.cpfForm?.get('nomStructure')?.value;
    const idNatStructure = this.cpfForm?.get('idNatStructure')?.value;
    let typeStructure = this.cpfForm?.get('typeStructure')?.value;
    let activite = this.cpfForm?.get('activite')?.value;
    let speciality = this.cpfForm?.get('speciality')?.value;
    if (!nomStructure) {
      this._modalSrv.openAlert(this._viewContainerRef, 'Erreur',
        'Le nom de la structutre est manquant.'
      );
    }
    if (!idNatStructure) {
      this._modalSrv.openAlert(this._viewContainerRef, 'Erreur',
        'L\'ID national est manquant.'
      );
    }
    if (!typeStructure) {
      this._modalSrv.openAlert(this._viewContainerRef, 'Erreur',
        'Le type de structure est manquant.'
      );
    } else {
      typeStructure = (typeStructure as string).split('++')[0];
    }
    if (!activite) {
      this._modalSrv.openAlert(this._viewContainerRef, 'Erreur',
        'L\'activité de la structure est manquant.'
      );
    } else {
      activite = (activite as string).split('++')[0];
    }
    if ((this._cpxCardType as unknown as CpxCardSignatureResponseInterface).s_professionOid === '1.2.250.1.71.1.2.8' && !speciality) {
      this._modalSrv.openAlert(this._viewContainerRef, 'Erreur',
        'La spécialité du PS est manquante.'
      );
    }
    this._cpxHandleSrv.setPracticeSetting({ nomStructure, idNatStructure, typeStructure, activite, specialite: speciality });
    this.closeModal({ data: this._cpxCardType, pinCode: this.pinCode });
  }

  public findCpxCard(): void {
    this.currentState = undefined;
    this._findCpxCard();
  }

  public closeModal(res?: HandleCpxResponse): void {
    this.currentStateMessageTpt = undefined;
    this.closeEmitterHandleCpx.emit(res);
  }

  private async _initData(): Promise<void> {
    this.isLoading = true;

    try {

      if (!this.typeConnecteur || this.typeConnecteur === TypeConnecteurEnum.DMPConnect) {
        const isCert = await this._cpxHandleSrv.isESConnexionIndirect(SessionTypeEnum.CERT_DMP);
        const isOpen = await this._cpxHandleSrv.isSessionOpen(isCert ? SessionTypeEnum.CERT_DMP : SessionTypeEnum.CARTE, this.typeConnecteur);

        const praLocAct = await this._cpxHandleSrv.getPracticeLocationActivity();
        if (!isOpen || (!isCert && (!praLocAct || !praLocAct.pinCode || praLocAct.practiceSettingIndice === null || praLocAct.practiceSettingIndice === undefined))) {
          await this._findCpxCard();
        }
      } else {
        const isOpen = await this._cpxHandleSrv.isSessionOpen(SessionTypeEnum.CERT_INSI, this.typeConnecteur);
        if (!isOpen) {
          await this._findCpxCard();
        }
      }
    } finally {
      this.isLoading = false;
    }
  }

  private async _openStellairConnexion(): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      if (!this._stellairSrv.isStellairAvailable.value) {
        loading.instance.message = 'Connexion à Stellair...\n\nUne action sur votre lecteur de carte Stellair est peut-être nécessaire';
        const token = await this._stellairSrv.getStellairAccessToken();
        if (token) {
          const terms = await this._stellairSrv.listTerminaux();
          // TODO Mettre une fonctionnalité pour sélectionner un lecteur si plusieurs présents
          if (terms && terms[0] && terms[0].id) {
            const healthcareToken = await this._stellairSrv.getHealthcareToken();
            if (healthcareToken) {
              loading.instance.reinitMessage();
            } else {
              this.currentStateMessageTpt = 'Une erreur est survenue lors l\'authentification auprès de Stellair';
              throw new StellairHealthcareTokenError(this.currentStateMessageTpt);
            }
          } else {
            this.currentStateMessageTpt = 'Une erreur est survenue lors de la récupération des terminaux Stellair disponibles';
            throw new StellairListTerminauxError(this.currentStateMessageTpt);
          }
        } else {
          this.currentStateMessageTpt = 'Impossible d\'aller plus loin sans se connecter à Stellair';
          throw new StellairAccessTokenError(this.currentStateMessageTpt);
        }
      }
    } catch (e) {
      if (
        e instanceof StellairAccessTokenError ||
        e instanceof StellairHealthcareTokenError ||
        e instanceof StellairListTerminauxError
      ) {
        throw e;
      } else {
        throw new WirelessConnectError(e);
      }
    } finally {
      loading.destroy();
    }
  }

  private async _findCpxCard(slotName?: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        let wirelessMode = false;
        if (!this.typeConnecteur || this.typeConnecteur === TypeConnecteurEnum.DMPConnect) {
          wirelessMode = await this._cpxHandleSrv.isWirelessMode(SessionTypeEnum.CARTE);
          if (wirelessMode) {
            this._cardSlotName = WIRELESS_MODE_CPX_CARD_NAME;
          } else {
            this._cardSlotName = await (await this._cpxHandleSrv.lectureCpxCard(slotName)).s_name;
          }
        } else if (this.typeConnecteur === TypeConnecteurEnum.DINNO) {
          const slots = (await this._dinnoSessionSrv.getSlots().toPromise())
          if (slots && slots.length == 1) {
            this._cardSlotId = slots[0].index;
          } else if (slots && slots.length > 1) {
            const selectedSlot = slots.find(s => s.nom === slotName);
            if (selectedSlot) {
              this._cardSlotId = selectedSlot.index;
            } else {
              throw new MultipleCpxCards(slots.map(s => s.nom));
            }
          } else {
            throw new NoCPXCard;
          }

        }

        if (!wirelessMode) {
          this.formGroupPinCode = this._formBuilder.group({
            pinCode: [environment.production ? '' : '', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]]
          });
          this.currentState = HandleCpxModalStateEnum.pinKeyboard;
          await this._focusPinCode();
          resolve();
        } else {
          await this._openStellairConnexion();
          if (this._stellairSrv.isStellairAvailable.value) {
            const accessToken = await this._stellairSrv.getStellairAccessToken();
            if (accessToken) {
              await this.readCard(accessToken);
            }
          }
          resolve();
        }
      } catch (e) {
        if (e instanceof MultipleCpxCards) {
          this._multipleCpxCards(e.slots);
        } else {
          this._handleCpxError(e);
          this.isLoading = false;
        }
      }
    });
  }

  private _multipleCpxCards(cpxCards: Array<string>): void {
    this.isLoading = false;
    this.multipleCpxCards = cpxCards;
    this.currentState = HandleCpxModalStateEnum.selectSlot;
  }

  private _setCpxType(type: any): CpxTypeEnum {
    if (type === CpxCardTypeEnum.CPS) {
      return CpxTypeEnum.CPS;
    } else if (type === CpxCardTypeEnum.CPE) {
      return CpxTypeEnum.CPE;
    } else if (type === CpxCardTypeEnum.CPF) {
      return CpxTypeEnum.CPF;
    } else {
      return undefined;
    }
  }

  private async _readCard(pinCode: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        if (!this.typeConnecteur || this.typeConnecteur === TypeConnecteurEnum.DMPConnect) {
          this._cpxCardType = await this._cpxHandleSrv.readCpx(this._cardSlotName, pinCode);
          this._cardSlotName = undefined;
          this.cpxType = this._setCpxType((this._cpxCardType as any)?.i_cpxType);
          const pls = this._cpxCardType.PracticeLocations ?? [];
          if (this.cpxType !== CpxTypeEnum.CPF) {
            if (pls.length === 0 || !this.showPracticeLocation || pls.length === 1) {
              if (pls.length === 0) {
                // Cas anormal : aucune situation d'exercice
                console.error('Aucune PracticeLocation trouvée sur la carte CPx');
                this.currentState = HandleCpxModalStateEnum.defaultError; // si vous avez ce state
                this._handleCpxError({ message: 'Aucune situation d’exercice trouvée sur la carte.' });
                resolve();
              }
              else if (!this.showPracticeLocation || pls.length === 1) {
                this.currentState = HandleCpxModalStateEnum.confirmationMessage;
                this._cpxHandleSrv.selectPracticeSettingIndice(0);
                this.closeModal({ data: this._cpxCardType, pinCode });
                resolve();
              }
            } else {
              // La présélection du premier lieu sélectionnable est faite par SelectPracticeLocationComponent
              this.practiceLocations = [];
              for (const pl of this._cpxCardType.PracticeLocations) {
                // const isDisabled = !SUBJECT_ROLE_CODES_AUTORIZED.includes(pl.s_practiceLocationActivity);
                this.practiceLocations.push({
                  id: pl.s_practiceLocationActivity,
                  libelle: pl.s_practiceLocationName,
                  meta: pl,
                  // disabled: isDisabled
                  disabled: false
                });

                // if (this.isUnautorizedPracticeLocation === false && isDisabled === true) {
                //   this.isUnautorizedPracticeLocation = isDisabled;
                // }
              }

              this.currentState = HandleCpxModalStateEnum.selectPracticeLocation;
              resolve();
            }
          } else {
            // load RefHealthcareFacilityTypeCodeDMP
            const healthcarefacilitytypecodesTmp = await this._refSrv.findRefListTableHypermed(ReferentielEnum.healthcarefacilitytypecode_dmp);
            if (healthcarefacilitytypecodesTmp && healthcarefacilitytypecodesTmp.length > 0) {
              this.healthcarefacilitytypecodes = healthcarefacilitytypecodesTmp.filter(h => h.sublibelle === '1.2.250.1.71.4.2.4');
            }
            // load RefPracticeSettingCodeDMP
            const practicesettingcodesTmp = await this._refSrv.findRefListTableHypermed(ReferentielEnum.practicesettingcode_dmp);
            if (practicesettingcodesTmp && practicesettingcodesTmp.length > 0) {
              this.practicesettingcodes = practicesettingcodesTmp.filter(h => h.sublibelle === '1.2.250.1.213.1.1.4.9');
            }

            let nomStructure = undefined;
            let idNatStructure = undefined;
            let typeStructure = this.healthcarefacilitytypecodes?.[0]?.id || undefined;
            let activite = this.practicesettingcodes?.[0]?.id || undefined;
            const profil = this._profilSrv.getCurrentProfil();
            if (profil) {
              const ressources = await this._ressourceSrv.getResourceSettings(profil.id, 'profil');
              // récupération du nom de la structure
              nomStructure = this._ressourceSrv.getSettingFromArray(ressources, 'dmp_params_nomstruct_setting')?.value;

              // récupération de l'idnat de la structure
              idNatStructure = this._ressourceSrv.getSettingFromArray(ressources, 'dmp_params_idnatstruct_setting')?.value;

              // récupération du type de structure
              const typeStructTmp = this._ressourceSrv.getSettingFromArray(ressources, 'dmp_params_typestruct_setting');
              if (typeStructTmp) {
                typeStructure = `${typeStructTmp.value}++1.2.250.1.71.4.2.4`;
              }

              // récupération de l'activité de la structure
              const activiteStructTmp = this._ressourceSrv.getSettingFromArray(ressources, 'dmp_params_practice_setting');
              if (activiteStructTmp) {
                activite = `${activiteStructTmp.value}++1.2.250.1.213.1.1.4.9`;
              }
            }

            this.cpfForm = this._formBuilder.group({
              nomStructure: [nomStructure, Validators.required],
              idNatStructure: [idNatStructure, Validators.required],
              typeStructure: [typeStructure, Validators.required],
              activite: [activite, Validators.required],
            });

            if ((this._cpxCardType as unknown as CpxCardSignatureResponseInterface).s_professionOid === '1.2.250.1.71.1.2.8') {
              if ((this._cpxCardType as unknown as CpxCardSignatureResponseInterface).s_profession === '10') {
                this.specialitiescodes = MedecinSpecialities.map(spe => {
                  return { id: spe.code, libelle: spe.libelle };
                });
              } else if ((this._cpxCardType as unknown as CpxCardSignatureResponseInterface).s_profession === '21') {
                this.specialitiescodes = PharmacienSpecialities.map(spe => {
                  return { id: spe.code, libelle: spe.libelle };
                });
              } else if ((this._cpxCardType as unknown as CpxCardSignatureResponseInterface).s_profession === '40') {
                this.specialitiescodes = ChirDentisteSpecialities.map(spe => {
                  return { id: spe.code, libelle: spe.libelle };
                });
              }
              this.cpfForm.addControl('speciality', new FormControl(undefined, Validators.required));
            }

            this.currentState = HandleCpxModalStateEnum.selectPracticeLocation;
            resolve();
          }
          this.pinCode = pinCode;
        } else if (this.typeConnecteur === TypeConnecteurEnum.DINNO){
          const situations = await this._dinnoSessionSrv.getSituations(this._cardSlotId, pinCode).toPromise();
          if (situations && situations.length > 0) {
            this.practiceLocations = [];
            for (const situation of situations) {
              this.practiceLocations.push({
                id: situation.index.toString(),
                libelle: situation.nom,
                meta: {
                  s_practiceLocationActivity: situation.activite,
                  s_practiceLocationHealthcareSettings: "",
                  s_practiceLocationName: situation.nom,
                  s_practiceLocationStructureId: situation.idNatStructure,
                  s_practiceLocationBillingNumber: ""
                }
              });
            }
            this.currentState = HandleCpxModalStateEnum.selectPracticeLocation;
            this.pinCode = pinCode;
            resolve();
          } else {
            throw new CpxCard("Aucune situation trouvée");
          }
        }
      } catch (e) {
        this._handleCpxError(e);
      } finally {
        this.isLoading = false;
      }
    });
  }

  private async _focusPinCode(): Promise<void> {
    const input = await this._getPinCodeInput();
    setTimeout(() => {
      input.focus();
    }, 0);

  }

  private async _emptyPinCode(): Promise<void> {
    const input = await this._getPinCodeInput();
    setTimeout(() => {
      input.value = '';
    }, 0);
  }

  private async _getPinCodeInput(): Promise<HTMLInputElement> {
    return new Promise<HTMLInputElement>(async (resolve) => {
      const rtd = document.querySelector('input#pinCode');
      if (rtd) {
        resolve(rtd as HTMLInputElement);
      } else {
        setTimeout(async () => {
          resolve(await this._getPinCodeInput());
        }, 200);
      }
    });
  }

  private async _handleCpxError(error: any): Promise<void> {
    if (error instanceof TooManyPinCodeError) {
      const modal = this._modalSrv.openAlert(this._viewContainerRef, 'Erreur',
        'Vous avez saisie 3 mauvais code PIN successivement. Cette carte CPX est désormais bloquée.'
      );
      const sub = modal.instance.closeEmitter.subscribe(() => {
        this.closeModal();
        modal.destroy();
        sub.unsubscribe();
      });
    } else if (error instanceof WrongPinCode) {
      this.isErrorWrongPin = true;
      await this._emptyPinCode();
      await this._focusPinCode();
    } else if (error instanceof NoCPXCard) {
      this.currentState = HandleCpxModalStateEnum.noCpxCard;
    } else if (error instanceof CpxCardRipped) {
      this.currentState = HandleCpxModalStateEnum.rippedCard;
    } else if (error instanceof CannotOpenSession) {
      this.currentState = HandleCpxModalStateEnum.unableToOpenSession;
    } else if (error instanceof ExpiredCardError) {
      this.currentState = HandleCpxModalStateEnum.expiredCard;
    } else if (error instanceof WirelessConnectError) {
      this.currentStateMessageTpt = error.message;
      this.currentState = HandleCpxModalStateEnum.wirelessConnectError;
    } else if (
      error instanceof StellairAccessTokenError ||
      error instanceof StellairHealthcareTokenError ||
      error instanceof StellairListTerminauxError
    ) {
      this.currentState = HandleCpxModalStateEnum.wirelessConnectError;
    } else {
      if (error.message) {
        this.currentStateMessageTpt = error.message;
      } else if (error.codeLabel) {
        this.currentStateMessageTpt = error.codeLabel;
      } else if (error.s_apiErrorExtendedInformations) {
        this.currentStateMessageTpt = error.s_apiErrorExtendedInformations;
      } else if (error.s_apiErrorDescription) {
        this.currentStateMessageTpt = error.s_apiErrorDescription;
      } else {
        this.currentStateMessageTpt = 'Une erreur inconnue est survenue';
      }
      this.currentState = HandleCpxModalStateEnum.defaultError;
    }
  }

}

export enum ConnectionType {
  cps = 'CPS',
  cpe = 'CPE',
  cpf = 'CPF',
  unknow = 'unknow'
}
